export default "__VITE_ASSET__CAuEc0wi__"